import React from "react";
import ViewCampaignPerformanceMetrics from "./view-campaign-performance-metrics/view-campaign-performance-metrics";

const CampaignPerformanceMetrics = () => {
  return (
    <div>
      <ViewCampaignPerformanceMetrics />
    </div>
  );
};

export default CampaignPerformanceMetrics;
